import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PlatformSettingsState } from './platform-settings.model';
import { featureKey } from './platform-settings.reducer';

const selectPlatformSettingsState = createFeatureSelector<PlatformSettingsState>(featureKey);

const selectPaymentMethods = createSelector(selectPlatformSettingsState, (state) => state.paymentMethods);
export const selectPaymentMethodsLoading = createSelector(selectPaymentMethods, (state) => state.loading);
export const selectPaymentMethodsLoaded = createSelector(selectPaymentMethods, (state) => state.loaded);
export const selectPaymentMethodsData = createSelector(selectPaymentMethods, (state) => state.data);
export const selectPaymentMethodsError = createSelector(selectPaymentMethods, (state) => state.error);

const selectCommon = createSelector(selectPlatformSettingsState, (state) => state.common);
export const selectCommonLoading = createSelector(selectCommon, (state) => state.loading);
export const selectCommonLoaded = createSelector(selectCommon, (state) => state.loaded);
export const selectCommonData = createSelector(selectCommon, (state) => state.data);
export const selectCommonError = createSelector(selectCommon, (state) => state.error);
